// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker__input-container {
	input {
		background: transparent;
	}
}


.modal__7Xgt {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;

	height: 100%;
	background: var(--_00000020-background);
	z-index: 1000;
	z-index: 9999999;
	display: inline-flex;
	align-items: center;
	justify-content: center;


	.modalContent_BX8tV {
		width: 100%;
		height: 100%;
		background: #ffffff;
		border-radius: 10px;
		padding: 10px;
		max-width: 500px;
		max-height: 500px;
		overflow-y: scroll;
		overflow-x: hidden;
	}
}



.header_rbcz9 {
	flex-direction: column;
	display: inline-flex;
	align-items: center;
	gap: 4px;
	width: 100%;
	/* width: calc(100% - 200px); */
	justify-content: space-between;
	background: var(--white-color);
	padding: 2px 0px;

	&::-webkit-scrollbar {
		display: none;
	}

	.top_HWDsl {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		/* flex-direction: column; */

		.buttons_Ai0qT {
			display: inline-flex;
			align-items: center;
			gap: 4px;

			svg {
				width: 20px;
				min-width: 20px;
				min-height: 20px;
			}
		}

		

		.expand_iVGcp {
			width: 33px;
			height: 33px;
			border: none;
			display: inline-flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			border-radius: 4px;
			background: var(--fa-background);

			&:hover {
				background: var(--border-color);
			}

			svg {
				min-width: 25px;
				min-height: 25px;
				width: 25px;
			}
		}

		.toDay_ix2XU {
			background: var(--fa-background);
			padding: 6px 12px;
			border-radius: 4px;
			border: none;
			outline: none;
			width: 77px;
			min-width: 60px;
			cursor: pointer;
			font-family: inherit;
			width: max-content;
			font-size: 18px;
			text-align: left;
		}

		.actualToday_sjU40 {
			border: none !important;
			outline: none;
			cursor: pointer;
			font-family: inherit;
			width: 77px;
			min-width: 77px;
			background-color: var(--_16c0982e-background);
			color: var(--_16c098-background);
			/* color: var(--white-color); */
			/* background: var(--_10a37f-background); */
			/* border: 1px solid var(--_10a37f-background); */
			padding: 2px 10px;
			width: max-content;
			border-radius: 4px;
			font-size: 17px;
		}

		.toReturn_DYJ1D {
			background: var(--_16c0982e-background);
			border: none;
			outline: none;
			cursor: pointer;
			font-family: inherit;
			border: 1px solid var(--border-color);
			padding: 6px 12px;
			width: max-content;
			border-radius: 4px;
			font-size: 17px;
		}

		.buttonsNavs_gYVjy {
			display: inline-flex;
			align-items: center;
			gap: 5px;

			button {
				display: inline-flex;
				justify-content: center;
				align-items: center;
				width: 40px;
				height: 40px;
				border-radius: 4px;
				border: 1px solid var(--border-color);
				background: var(--_10a37f-background);
				color: var(--_16c098-background);
				cursor: pointer;

				svg {
					min-width: 26px;
					min-height: 26px;
					color: var(--_16c0982e-background);
					fill: transparent;
					width: 26px;
				}

				&:hover {
					background: var(--_16c098-background);
					color: var(--_10a37f-background);
				}
			}
		}
	}

	[class^='react-datepicker-wrapper'] {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		padding: 10px 10px;
		height: 40px;
		border-radius: 4px;
		border: 1px solid var(--border-color);

		input {
			width: 110px;
			outline: none;
		}
	}

	.buttonsCalendars_Ih4g3 {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		overflow-x: scroll;
		flex-direction: column;

		&::-webkit-scrollbar {
			display: none;
		}

		button {
			background: var(--fa-background);
			border: none;
			outline: none;
			cursor: pointer;
			font-family: inherit;
			border: 1px solid var(--border-color);
			padding: 1px 7px;
			border-radius: 4px;
			font-size: 18px;
			display: inline-flex;
			align-items: center;
			justify-content: center;

			&.active_NHxBQ {
				border-color: var(--_10a37f-background);
				color: var(--_10a37f-background);
			}

			&:hover {
				border-color: var(--_16c098-background);
				color: var(--_16c098-background);
			}

			svg {
				min-width: 20px;
				width: 20px;
			}
		}
	}
}

.kanbanButton_pEP1d {
	background: var(--fa-background);
	border: none;
	outline: none;
	cursor: pointer;
	font-family: inherit;
	align-items: center;
	justify-content: center;
	border: 1px solid var(--border-color);
	padding: 6px 4px 6px 12px;
	width: max-content;
	text-wrap: nowrap;
	border-radius: 4px;
	font-size: 17px;
	display: flex;
	flex-direction: row;
	gap: 2px;

	&.active_NHxBQ {
		border-color: var(--_10a37f-background);
		color: var(--_10a37f-background);
	}

	&:hover {
		border-color: var(--_16c098-background);
		color: var(--_16c098-background);
	}

	svg {
		min-width: 22px;
		width: 22px;
	}
}

.container_aR43l {
	width: 100%;
	background: #fff;
	border-radius: 20px 0px 0px 0px;
	overflow: hidden;

	.app_G708t {
		background: var(--white-color);
		position: relative;
		display: flex;
		align-items: flex-start;
		gap: 2px;
		height: 100%;
		overflow: hidden;
		/* height: calc(100vh - 88px); */
		overflow: hidden;
		/* display: flex; */
		flex-direction: row;
		width: 100%;

	}
}

.firstTh_hs73u {
	border-bottom: none !important;
}

.hourZoneWrapper_g1lsX {
	position: relative;
	background: var(--f5-background) !important;
	border-top: none !important;
}

.weekHourContent_Ae1Xi {
	position: relative !important;
}

.hourContent_KJ3mB {
	padding-left: 10px;
	position: relative !important;
	display: flex;
	border-top: none !important;
	flex-direction: row;
}

.eventPopup_mEC6S {
	position: absolute !important;
	top: 97px;
	border-radius: 8px;
	z-index: 700000;
}

.selectedHourContent_BDrj2 {
	display: flex;
	width: 100%;
	margin-right: 2px;
	padding: 2px 5px;
	flex-direction: column;
	border-radius: 4px;
	justify-content: flex-start;
	color: var(--white-color);
	align-items: flex-start;
	font-size: 12px;
	font-weight: 500;
	height: 100%;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	opacity: 0.8;
	position: relative;
	transition: all 0.2s ease-in-out;

	&:hover {
		opacity: 1;
	}
}

.monthTr_TgRMB {
	width: 100%;
}

.monthTd_hiuCq {
	position: relative;
	min-width: 150px;
}

.monthDayHeader_Dovx6 {
	font-weight: 600;
	font-size: 15px;
	align-items: center;
	justify-content: center;
	height: 35px;
	border: none !important;
}

.hourZoneInner_dW1NU {
	position: absolute;
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	bottom: -1px;
	width: calc(100% - 10px);
	right: 10px;
	z-index: 100000;
	background: var(--f5-background);
	color: var(--_10a37f-background);
	padding: 2px 8px;
	font-size: 11px;
	font-weight: 500;
}

.dayMonthContainer_jEkmT {
	position: relative;
}

.dayMonthInnerContainerWrapper_XHqjA {
	position: absolute;
	padding-left: 5px;
	left: -1px;
	top: 0;
	padding-top: 5px;
	width: calc(100% + 1px);
	background: var(--f5-background);
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;
}

.dayMonthInnerContainerWrapperWeek_N0aTW {
	position: absolute;
	padding-left: 5px;
	left: -1px;
	top: 0;
	padding-top: 5px;
	width: calc(100% + 1px);
	background: var(--f5-background);
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	z-index: 100000;
}

.dayMonthInnerContainer_uathQ {
	display: flex;
	padding-left: 5px;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
}

.dayText_uIG3J {
	color: var(--_16c098-background);
	font-weight: 500;
	font-size: 12px;
}

.dayCircle_Hu14e {
	width: 45px;
	height: 45px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	font-size: 26px;
	padding-right: 1px;
	font-weight: 500;
	background-color: var(--_16c098-color);
	color: var(--white-color);
}

.selectedDayCircle_TneJq {
	width: 45px;
	height: 45px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	font-size: 26px;
	padding-right: 1px;
	font-weight: 500;
	background-color: var(--_16c098-background);
	color: var(--white-color);
}

.hourContainer_I2UMR {
	position: absolute;
	top: -9px;
	right: 10px;
	background: var(--f5-background);
	width: calc(100% - 10px);
	padding-right: 5px;
}

.belowGMTTd_SBo_F {
	background: var(--f5-background);
	border-left: none !important;
	max-width: 70px !important;
}

.closeWrapper_rVJWA {
	width: 20px;
	height: 20px;
	line-height: 17px;
	margin-left: 6px;
	background-color: #dc3545;
	border-radius: 50%;
	font-size: 20px;
	color: var(--white-color);
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	display: none;

	&:hover {
		background: red;
	}
}

.kanbanButton_pEP1d {
	&:hover {
		.closeWrapper_rVJWA {
			display: flex;
		}
	}
}

.closeWrapper_rVJWA svg {
	color: var(--e6fff9-background);
}

.closeWrapper_rVJWA:hover svg {
	color: var(--white-color);
}

.tableCalendar_cHS0D {
	width: 100%;
	height: 100%;
	overflow: scroll;

	table {
		height: 100%;
		width: 100%;
		border: none;

		th {
			text-align: left;
			min-height: 100px;
		}

		td {
			border: 1px solid var(--border-color);
			text-align: center;
			background-color: var(--white-color);

			&.active_NHxBQ {
				background: var(--_16c09821-background);
				border-color: var(--_16c098-color);
				color: var(--_16c098-color);
				cursor: pointer;

				&:hover {
					background: var(--e6fff9-background);
					border-color: var(--_16c09821-background);
					color: var(--_16c09821-background);
				}
			}
		}

		&.calendarDay_HenOX {
			min-width: 750px;

			th,
			td {
				width: 7%;
				min-height: 40px;
				height: 40px;
			}

			th:nth-child(1),
			td:nth-child(1) {
				position: relative;
				min-width: 70px;
				width: 70px;
				background: var(--f5-background);
				color: var(--_10a37f-background);
				border-color: var(--border-color);
				border-left: none !important;
				border-right: none !important;
				padding: 2px 5px;
				font-size: 11px;
				font-weight: 500;
				text-align: right;
			}

			th {
				background: var(--_16c0982e-background);
				color: var(--_10a37f-background);
				border-color: var(--_16c0982e-background);
				padding: 2px 9px;
				font-size: 15px;
				font-weight: 600;
			}

			th:nth-child(1) {
				background: var(--f5-background);
			}

			th:nth-child(2),
			td:nth-child(2) {
				width: 100%;
			}
		}

		&.calendarWeek_g6m6U {
			min-width: 750px;

			th,
			td {
				width: 11vw !important;
				min-height: 40px;
				height: 40px;
			}

			tbody {
				background-color: var(--f5-background);
			}

			th:nth-child(1),
			td:nth-child(1) {
				position: relative;
				min-width: 70px;
				width: 70px !important;
				background: var(--f5-background);
				color: var(--_10a37f-background);
				border-color: var(--border-color);
				border-left: none !important;
				border-right: none !important;
				padding: 2px 5px;
				font-size: 11px;
				font-weight: 500;
				text-align: right;
			}

			th {
				background: var(--_16c0982e-background);
				color: var(--_10a37f-background);
				border-color: var(--_16c0982e-background);
				padding: 2px 9px;
				font-size: 15px;
				font-weight: 600;
			}

			th:nth-child(1) {
				background: var(--f5-background);
			}
		}

		&.calendarMonth_mrg9s {
			min-width: 750px;
			/* border: 1px solid var(--f5-background); */

			th,
			td {
				width: calc(100% / 7);
			}

			table {
				border-top: none !important;
				border-radius: 0;
			}

			thead {
				border: none !important;
				border-radius: 0;
			}

			th {
				text-align: center;
				border-radius: 0;
				border-bottom: none;
				color: var(--_10a37f-background);
				border: none !important;
				font-size: 11px;
				padding-top: 2px;
			}

			td {
				height: calc((100vh / 5) - 26px);

				.day_rDfh9 {
					display: inline-flex;
					flex-direction: column;
					position: relative;
					align-items: center;
					justify-content: flex-start;
					height: 100%;
					max-height: 175px;
					width: 100%;

					b {
						font-size: 14px;
						font-weight: 800;
					}

					ul {
						margin-top: 4px;
						display: inline-flex;
						flex-direction: column;

						li {
							display: block;
							display: inline-flex;
							flex-direction: column;
							align-items: center;

							.date_n27pq {
								display: flex;
								align-items: center;
								justify-content: flex-start;
								gap: 8px;

								.dot_AFUac {
									width: 10px;
									height: 10px;
									border-radius: 2px;
									background: var(--_16c0982e-background);
									margin: 0;
									padding: 0;

									&.active_NHxBQ {
										background: var(--_10a37f-background);
									}
								}

								span {
									font-size: 11px;
									font-weight: 500;
								}
							}

							.info_xRorD {
								width: 80px;
								font-size: 10px;
								font-weight: 600;
								background: var(--white-color);
								border-radius: 6px;
								padding: 2px 4px;
								text-wrap: nowrap;
								cursor: pointer;

								&::-webkit-scrollbar {
									display: none;
								}

								&:hover {
									background: var(--f5-background);
								}

								span {
									font-size: 10px;
									font-weight: 400;
								}

								b {
									width: 100px;
									font-size: 14px;
									font-weight: 600;
								}
							}
						}
					}
				}
			}
		}

		&.schedule_avT8i {
			min-width: 750px;

			th {
				border-color: var(--_16c0982e-background);
				background: var(--_16c0982e-background);
				color: var(--_10a37f-background);
				font-size: 14px;
				font-weight: 500;
				padding: 4px 10px;
				font-size: 16px;
				font-weight: 600;
			}

			td:nth-child(1),
			td:nth-child(2) {
				padding: 10px;
				background: var(--white-color);
				text-align: center;
				font-size: 12px;
				font-weight: 600;
			}

			tr:last-child {
				td {
					border-bottom: none;
				}

				td:nth-child(1),
				td:nth-child(2) {
					background: var(--f5-background);
				}
			}

			.events_jBCzF {
				background: var(--f5-background);
				display: inline-flex;
				flex-direction: column;
				gap: 2px;
				width: 100%;
				padding: 10px;

				.item_GTNjI {
					display: flex;
					flex-direction: column;
					gap: 2px;
					border: 1px solid var(--border-color);
					padding: 6px;
				}

				strong {
					font-size: 10px;
					text-transform: uppercase;
					line-height: 2px;
					margin-top: 7px;
				}

				.headerEvent_gcUz3 {
					display: inline-flex;
					align-items: center;
					width: 100%;
					justify-content: space-between;
					background: var(--white-color);
					padding: 4px 10px;

					div {
						display: flex;
						align-items: center;
						gap: 8px;

						label {
							background: var(--_10a37f-background);
							color: var(--_16c0982e-background);
							padding: 2px 8px;
							border-radius: 4px;
							font-size: 10px;
							font-weight: 700;
						}
					}
				}
			}
		}

		&.timeLine_g2iSz {
			min-width: 750px;

			thead {
				th:nth-child(1) {
					font-size: 14px;
					font-weight: 500;
					padding: 4px 10px;
					font-size: 23px;
					font-weight: 600;
				}

				th {
					background: var(--_16c0982e-background);
					color: var(--_10a37f-background);
					border-color: var(--_16c0982e-background);
					font-size: 12px;
					font-weight: 600;
					padding: 6px;
				}

				tr:nth-child(1) {
					th {
						padding: 2px 9px;
						font-size: 15px;
						font-weight: 600;
						background: var(--white-color);
						border-color: var(--border-color);
					}
				}
			}

			td:nth-child(1) {
				min-width: 230px;
				width: 230px;
				padding: 10px;
				font-size: 14px;
				font-weight: 600;
				background: var(--_16c0982e-background);
				color: var(--_10a37f-background);
				border-color: var(--_16c0982e-background);
				text-align: left;
			}
		}
	}
}

.notScrollableTableCalendar_RUaAN {
	overflow: hidden !important;
}

.calendarDayHeader_INPaM {
	min-height: 100px !important;
}

.monthDayLi_R5qKO {
	padding: 3px;
	border-radius: 2px;
	display: flex;
	width: 100%;
	min-width: 140px;
	position: relative !important;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	justify-content: flex-start !important;
	align-items: flex-start !important;

	&:hover {
		background: var(--border-color);
	}

	div {
		span {
			max-width: 90%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
}

.monthDayContainer_Ykmro {
	margin: 2px;
	border-radius: 5px;
	font-size: 10px;
	width: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 25px;
	font-weight: 400 !important;
	background-color: var(--_16c0982e-background);
	color: var(--_16c098-background);
}

.selectedMonthDayContainer_UilE6 {
	margin: 2px;
	border-radius: 50%;
	font-size: 10px;
	width: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 25px;
	font-weight: 400 !important;
	background-color: var(--_16c098-background);
	color: var(--white-color);
}

.scheduleWrapper_tzOni {
	min-width: 750px;
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	justify-content: flex-start;
	width: 100%;
}

.scheduleEventsContainer_f2TD4 {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;
	width: 100%;
}

.calendarSchedule_aZQ2O{
padding: 8px;
}

.calendarContainer_RC5hh {
	width: 100%;
	height: 100%;
	flex: 1 1 auto; 
  min-width: 0
	/* padding: 20px; */
	/* background-color: var(--f5-background); */
}

.navigation_NFqBV {
	margin-bottom: 10px;
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	padding: 10px;
	background-color: var(--_16c0982e-background);
	border-radius: 8px 8px 0px 0px;
	box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.2);
}

.monthLabel_fmiw6 {
	font-weight: bold;
	font-size: 18px;
	color: var(--_10a37f-background);
}

.daysRow_fow4f {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	background: transparent;
}

.dayHeader_sDDPU {
	flex: 1 1;
	text-align: center;
	padding: 10px;
	font-weight: bold;
	background-color: var(--_16c0982e-background);
	color: var(--_10a37f-background);
	border-radius: 5px;
	margin-right: 2px;
	box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);
}

.weekRows_o4cLy {
	display: flex;
	flex-direction: column;
}

.weekRow_F9BnA {
	display: flex;
	margin-bottom: 2px;
}

.dayCell_kT95W {
	flex: 1 1;
	min-height: 100px;
	padding: 10px;
	-webkit-user-select: none;
	        user-select: none;
	margin-right: 2px;
	border-radius: 4px;
	position: relative;
	background-color: var(--_16c098-color);
	box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.2);
}

.dateNumber_sPgvB {
	font-weight: bold;
	margin-bottom: 5px;
	color: var(--_10a37f-background);
}

.eventText_q5Blh {
	background-color: var(--_16c09821-background);
	padding: 5px;
	border-radius: 5px;
	color: var(--_10a37f-background);
	font-size: 12px;
	text-align: center;
}

.chevronContainer_DTLKa {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	background: var(--_16c0982e-background);
	transition:
		background 0.2s ease-in-out,
		transform 0.1s ease-in-out;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	font-size: 18px;
	color: var(--_10a37f-background);
	width: 40px;
	height: 35px;

	&:hover {
		background: var(--_16c0982e-background);
		transform: scale(1.05);
	}

	&:active {
		background: var(--_16c098-color);
		transform: scale(0.95);
	}


}

.calendarMonthWrapper_roQw3 {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	max-width: 100px;
    /* max-height: 500px; */
    overflow-y: visible;
}

.calendarMonth_mrg9s thead th {
    position: sticky;
    top: 0;
    background: var(--fa-background);
    z-index: 1;
}


.timeline_ZIg05 {
	display: flex;
	width: 100%;
	height: 100%;
	padding: 10px 20px 10px 70px;
	flex-direction: column;
	/* min-width: 990px; */
	max-width: 100%;
	background-color: var(--fa-background);
	position: relative;
}

.timelineHeader_WfKWP {
	display: flex;
	justify-content: space-between;
	border-radius: 4px;
	align-items: center;
	padding: 0px 5px;
	height: 35px;
	margin-bottom: 10px;
	font-size: 12px;
	background-color: var(--_16c0982e-background);
	border: 1px solid var(--_16c0982e-background);

	span {
		font-size: 14px;
		color: var(--_16c09821-background);
		font-weight: 600;
	}
}

.dayContainer_go5p3 {
	display: flex;
	height: 35px;
	min-height: 35px;
	align-items: center;
	justify-content: flex-start;

	border: 1px solid var(--border-color);
	border-radius: 4px;
	margin-bottom: 15px;
	position: sticky;
	top: 0;
	background: #fff;
	z-index: 2;
}

.navArrowsContainer_FbdjL {
	display: flex;
	align-items: center;
	justify-content: center;
}

.navArrow_cIh7r {
	background-color: var(--_16c09821-background);
	color: var(--_16c098-background);
	border: none;
	height: 100%;
	font-size: 11px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	border-radius: 3px 0px 0px 3px;
	cursor: pointer;
	transition:
		background 0.2s ease-in-out,
		transform 0.1s ease-in-out;

	&:hover {
		background: var(--e6fff9-background);
		transform: scale(1.05);
	}

	&:active {
		background: var(--_16c09821-background);
		transform: scale(0.95);
	}
}

.navArrowRight_VLRZW {
	background-color: var(--_16c09821-background);
	color: var(--_16c098-background);
	border: none;
	height: 100%;
	font-size: 11px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	border-radius: 0px 3px 3px 0px;
	cursor: pointer;
	position: fixed;
	right: 27px;
	/* top: 71px; */
	height: 33px;

	z-index: 50000;
	transition:
		background 0.2s ease-in-out,
		transform 0.1s ease-in-out;

	&:hover {
		background: var(--e6fff9-background);
		transform: scale(1.05);
	}

	&:active {
		background: var(--_16c09821-background);
		transform: scale(0.95);
	}
}

@media (max-width: 1308px) {
	.navArrowRight_VLRZW {
		right: 0px;
	}
}

.timelineDays_Hip3z {
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.timelineDay_QE4Pm {
	text-align: start;
	padding: 0px 5px;
	height: 100%;
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: 600;
	/* color: var(--_16c09821-background); */
	background-color: var(--_16c098-background);
    color: var(--white-color);
}

.eventsContainer_qvaHv {
	display: flex;
	width: 100%;
	position: relative;
	background-color: var(--white-color);
	height: 100%;
}

.timelineEvents_rpZl_ {
	display: flex;
	margin-top: 2px;
	width: calc(100% - 60px);
	justify-content: flex-start;
	align-items: flex-start;
	margin-left: 30px;
	z-index: 50000;
	position: relative;
}

.eventsForDay_IJK3q {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	overflow-x: show;
	gap: 3px;
	overflow-y: auto;
}

.timelineEvent_LaVyS {
	background-color: #cfe9ff;
	color: #000;
	justify-content: center;
	border-radius: 5px;
	text-align: center;
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.timelineEventCard_NOVbf {
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 3px;
	height: 50px;
	min-height: 50px;
	padding: 0px 5px;
	align-items: center;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	align-items: center;
	justify-content: flex-start;
	position: relative;
	border-radius: 3px;

	&:hover {
		background-color: var(--_16c0982e-background);

		.eventDesc_LDNmf {
			color: var(--white-color);
		}
	}
}

.eventColorDiv_Xzzwe {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	height: 37px;
	min-width: 8px;
	border-radius: 15px;
	width: 8px;
}

.eventRightContainer_BW1AF {
	display: flex;
	align-items: center;
	width: 100%;
	justify-content: flex-start;
	gap: 3px;
	flex-direction: row;
}

.eventUserImage_kbsbZ {
	display: flex;
	width: 27px;
	max-width: 27px;
	min-width: 27px;
	height: 27px;
	max-height: 27px;
	min-height: 27px;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	font-weight: bold;
	border-radius: 50px;
	color: var(--white-color);
	background-color: var(--_16c098-color);
}

.eventData_PsfH9 {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	height: 100%;
	flex-direction: column;
}

.eventTitle_vDKOH {
	color: var(--_3c3a3a-color);
	font-size: 13px;
	white-space: nowrap;
	overflow: hidden;
	font-weight: 600;
	text-overflow: ellipsis;
	line-height: 1.2;
}

.eventDesc_LDNmf {
	color: var(--text-color-secondary);
	font-size: 11px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1;
}

.eventTitle_vDKOH,
.eventDesc_LDNmf {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	transition: max-width 0.3s ease-in-out;
}

.timelineEventCard_NOVbf:hover .eventTitle_vDKOH,
.timelineEventCard_NOVbf:hover .eventDesc_LDNmf {
	max-width: none !important;
}

.showMoreButton_Xmf3H {
	color: var(--_16c0982e-background);
	cursor: pointer;
	font-size: 12px;
	margin-left: -2px;
	font-weight: 600;
	text-align: center;
	width: 100%;

	&:hover {
		color: var(--_16c098-color);
	}
}

.hoursWrapper_soiYt {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	flex-direction: column;
	border-radius: 5px;
	border: 1px solid var(--_16c0982e-background);
	background-color: var(--white-color);
}

.hourItem_sr1Al {
	font-size: 11px;
	position: relative;
	display: flex;
	margin-left: -22px;
	align-items: flex-start;
	color: var(--_10a37f-background);
	justify-content: flex-start;
	font-weight: 500;
	width: 100%;
	border-bottom: 1px solid var(--border-color);
}

.hourTextAbsolute_WzKbw{
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	position: absolute;
	height: 100%;
	left: -50px;
	background-color: var(--fa-background);
    padding: 20px 20px;
    width: 20px;
    border-right: 1px solid #d5f4dc;
}

.hourText_GFq3n {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	position: sticky;
	left: 0;
	background-color: var(--fa-background);
    padding: 20px 20px;
    width: 20px;
    border-right: 1px solid #d5f4dc;
}


.eventListContainer__iDsP {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	padding: 0px 4px;
	gap: 2px;
}


.singleEventCardContainer_Rv5xD {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	background-color: transparent;
	padding: 10px;
	width: 100%;
	gap: 20px;
	border-top: 1px solid var(--border-color);
	cursor: pointer;
}

.lastSingleEventCardContainer_m84W6 {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	background-color: transparent;
	padding: 10px;
	width: 100%;
	gap: 20px;
	border-bottom: 1px solid var(--border-color);
	border-top: 1px solid var(--border-color);
	cursor: pointer;
}

.dateContainer_FTySb {
	padding: 3px;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 15px;
	color: #333;
	font-weight: 600;
	min-width: 70px;
}

.eventPopup_mEC6S {
	position: absolute;
	top: 97px;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 8px;
	z-index: 700000;
}

.itemContainer_R4lMz {
	display: flex;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	align-items: flex-start;
	position: relative;
	width: 100%;
	justify-content: flex-start;
	padding: 8px;
	border-radius: 5px;
	gap: 20px;
	transition: background 0.01s ease-in-out;

	&:hover {
		background: var(--_16c0982e-background);
	}
}

.day_rDfh9 {
	font-size: 18px;
	font-weight: bold;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	width: 30px;
	height: 30px;
	min-width: 30px;
	min-height: 30px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--_3c3a3a-color);
	transition: background 0.01s ease-in-out;
}

.monthDayName_yEjK3 {
	font-size: 12px;
	color: var(--text-color-secondary);
	width: 80px;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: row;
}

.timeContainer_Ep8Ln {
	display: flex;
	align-items: center;
	min-width: 160px;
}

.dot_AFUac {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: var(--_16c09821-background);
	margin-right: 15px;
	margin-bottom: 2px;
}

.eventsContainer_qvaHv {
	display: flex;
	width: 100%;
	align-items: flex-start;
	flex-direction: column;
	gap: 5px;
	justify-content: flex-start;
}

.hour_BMBiE {
	font-size: 14px;
	font-weight: 600;
	color: var(--text-color-secondary);
}

.eventDetails_SFdN4 {
	flex-grow: 1;
	padding-left: 10px;
}

.title_vw2TJ {
	font-size: 14px;
	font-weight: bold;
	color: var(--_3c3a3a-color);
	margin-bottom: 2px;
}

.description_baU6K {
	font-size: 12px;
	color: var(--text-color-secondary);
}

.inputCalendarContainer_n8n9Y {
	position: relative;
	display: inline-block;
	z-index: 99999999;
	min-width: 120px;
	max-width: 120px;
}

.inputWrapper__JgCc {
	display: flex;
	align-items: center;
	background: var(--_16c0982e-background);
	border: 1px solid var(--border-color);
	padding: 6px 12px;
	height: 100%;
	border-radius: 4px;
}

.dateInput_Dw6Mw {
	border: none;
	outline: none;
	width: 100%;
	text-align: center;
	cursor: pointer;
	font-size: 17px;
	background: transparent;
	color: var(--_3c3a3a-color);
}

.clearButton_F_48g {
	background: none;
	border: none;
	cursor: pointer;
	font-size: 16px;
	margin-left: auto;
	color: var(--_3c3a3a-color);
}

.calendarPopup_wwtfX {
	position: absolute;
	top: 100%;
	left: 0;
	flex-direction: column;
	z-index: 100;
	background-color: white;
	border: 1px solid var(--border-color);
	border-radius: 4px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	padding: 10px;
	margin-top: 5px;
	z-index: 100000;
}

.miniCalendarWrapper_r2YSw {
	background: var(--f5-background);
	border-radius: 10px;
	padding: 2px;
	overflow: hidden;
}

.date_n27pq {
	display: flex;
	align-items: center;
	gap: 2px;
	justify-content: space-between;

	b {
		font-size: 12px;
		font-weight: 600;
	}

	div {
		display: flex;
		align-items: center;
		gap: 10px;

		button {
			transition:
				background 0.2s ease-in-out,
				transform 0.1s ease-in-out;
			cursor: pointer;
			-webkit-user-select: none;
			        user-select: none;
			padding: 3px;
			background: var(--_16c0982e-background);
			color: var(--_10a37f-background);
			border-radius: 6px;

			&:hover {
				background: var(--_16c0982e-background);
				transform: scale(1.05);
			}

			&:active {
				background: var(--_16c098-color);
				transform: scale(0.95);
			}

			svg {
				width: 8px;
				height: 8px;
			}
		}
	}
}

.topDropContainer_MSRW4 {
	display: flex;
	width: 100%;
	height: 50px;
	min-height: 50px;
}

.botDropContainer_xPpCO {
	display: flex;
	width: 100%;
	height: 50px;
	min-height: 50px;
}

.dot_AFUac {
	min-width: 10px;
	width: 10px;
	height: 10px;
	border-radius: 3px;
	background: var(--border-color);

	&._100_ficDJ {
		background: var(--_10a37f-background);
	}

	&._101_vNx34 {
		background: var(--_16c098-background);
	}

	&._102_H_Mpk {
		background: var(--e6fff9-background);
	}

	&._103_HQbpP {
		background: var(--_16c09821-background);
	}

	&._200_u3uNT {
		background: #dadada;
	}

	&._201_o56jw {
		background: #ffa914;
	}

	&._202_ZyL8V {
		background: #f7ff14;
	}

	&._203_e6ieT {
		background: rgb(255, 30, 30);
	}

	&._204_r4_sz {
		background: rgb(17, 209, 113);
	}
}

.newKanbanInput_q0Gy_ {
	display: flex;
	border: none;
	outline: none;
	width: 80px;
}

.menu_OCnUV{
    width: 300px;   /* O el ancho que prefieras */
  max-width: 300px;
  min-width: 220px;
  flex: 0 0 300px;
}

@media (max-width: 600px) {
	.menu_OCnUV {
	  display: none !important;
	}
  }

.leftTimezone_fW17U{
	height: 65px;
	background: var(--fa-background);
	width: 70px;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	z-index: 2;
	font-size: 11px;
	color: var(--_16c098-background);
	font-weight: 600;
	padding-bottom: 8px;
	border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/index.module.css"],"names":[],"mappings":"AAAA;CACC;EACC,uBAAuB;CACxB;AACD;;;AAGA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;;CAEX,YAAY;CACZ,uCAAuC;CACvC,aAAa;CACb,gBAAgB;CAChB,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;;;CAGvB;EACC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;CACnB;AACD;;;;AAIA;CACC,sBAAsB;CACtB,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,WAAW;CACX,+BAA+B;CAC/B,8BAA8B;CAC9B,8BAA8B;CAC9B,gBAAgB;;CAEhB;EACC,aAAa;CACd;;CAEA;EACC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;;EAE5B;GACC,oBAAoB;GACpB,mBAAmB;GACnB,QAAQ;;GAER;IACC,WAAW;IACX,eAAe;IACf,gBAAgB;GACjB;EACD;;;;EAIA;GACC,WAAW;GACX,YAAY;GACZ,YAAY;GACZ,oBAAoB;GACpB,sBAAsB;GACtB,uBAAuB;GACvB,mBAAmB;GACnB,eAAe;GACf,kBAAkB;GAClB,gCAAgC;;GAEhC;IACC,+BAA+B;GAChC;;GAEA;IACC,eAAe;IACf,gBAAgB;IAChB,WAAW;GACZ;EACD;;EAEA;GACC,gCAAgC;GAChC,iBAAiB;GACjB,kBAAkB;GAClB,YAAY;GACZ,aAAa;GACb,WAAW;GACX,eAAe;GACf,eAAe;GACf,oBAAoB;GACpB,kBAAkB;GAClB,eAAe;GACf,gBAAgB;EACjB;;EAEA;GACC,uBAAuB;GACvB,aAAa;GACb,eAAe;GACf,oBAAoB;GACpB,WAAW;GACX,eAAe;GACf,6CAA6C;GAC7C,gCAAgC;GAChC,+BAA+B;GAC/B,2CAA2C;GAC3C,iDAAiD;GACjD,iBAAiB;GACjB,kBAAkB;GAClB,kBAAkB;GAClB,eAAe;EAChB;;EAEA;GACC,uCAAuC;GACvC,YAAY;GACZ,aAAa;GACb,eAAe;GACf,oBAAoB;GACpB,qCAAqC;GACrC,iBAAiB;GACjB,kBAAkB;GAClB,kBAAkB;GAClB,eAAe;EAChB;;EAEA;GACC,oBAAoB;GACpB,mBAAmB;GACnB,QAAQ;;GAER;IACC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;;IAEf;KACC,eAAe;KACf,gBAAgB;KAChB,kCAAkC;KAClC,iBAAiB;KACjB,WAAW;IACZ;;IAEA;KACC,qCAAqC;KACrC,gCAAgC;IACjC;GACD;EACD;CACD;;CAEA;EACC,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;;EAErC;GACC,YAAY;GACZ,aAAa;EACd;CACD;;CAEA;EACC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;;EAEtB;GACC,aAAa;EACd;;EAEA;GACC,gCAAgC;GAChC,YAAY;GACZ,aAAa;GACb,eAAe;GACf,oBAAoB;GACpB,qCAAqC;GACrC,gBAAgB;GAChB,kBAAkB;GAClB,eAAe;GACf,oBAAoB;GACpB,mBAAmB;GACnB,uBAAuB;;GAEvB;IACC,uCAAuC;IACvC,gCAAgC;GACjC;;GAEA;IACC,uCAAuC;IACvC,gCAAgC;GACjC;;GAEA;IACC,eAAe;IACf,WAAW;GACZ;EACD;CACD;AACD;;AAEA;CACC,gCAAgC;CAChC,YAAY;CACZ,aAAa;CACb,eAAe;CACf,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,qCAAqC;CACrC,yBAAyB;CACzB,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,QAAQ;;CAER;EACC,uCAAuC;EACvC,gCAAgC;CACjC;;CAEA;EACC,uCAAuC;EACvC,gCAAgC;CACjC;;CAEA;EACC,eAAe;EACf,WAAW;CACZ;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,+BAA+B;CAC/B,gBAAgB;;CAEhB;EACC,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;;CAEZ;AACD;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,2BAA2B;AAC5B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,6BAA6B;CAC7B,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;CAC7B,SAAS;CACT,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,2BAA2B;CAC3B,yBAAyB;CACzB,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,wCAAwC;CACxC,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,gCAAgC;;CAEhC;EACC,UAAU;CACX;AACD;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,qBAAqB;CACrB,yBAAyB;CACzB,YAAY;CACZ,wBAAwB;CACxB,WAAW;CACX,eAAe;CACf,gCAAgC;CAChC,gCAAgC;CAChC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;CACV,MAAM;CACN,gBAAgB;CAChB,uBAAuB;CACvB,gCAAgC;CAChC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;CACV,MAAM;CACN,gBAAgB;CAChB,uBAAuB;CACvB,gCAAgC;CAChC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,mBAAmB;CACnB,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,sCAAsC;CACtC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,2CAA2C;CAC3C,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,gCAAgC;CAChC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;CAChC,4BAA4B;CAC5B,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,aAAa;;CAEb;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC;GACC,aAAa;EACd;CACD;AACD;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;;CAEhB;EACC,YAAY;EACZ,WAAW;EACX,YAAY;;EAEZ;GACC,gBAAgB;GAChB,iBAAiB;EAClB;;EAEA;GACC,qCAAqC;GACrC,kBAAkB;GAClB,oCAAoC;;GAEpC;IACC,uCAAuC;IACvC,kCAAkC;IAClC,2BAA2B;IAC3B,eAAe;;IAEf;KACC,oCAAoC;KACpC,yCAAyC;KACzC,kCAAkC;IACnC;GACD;EACD;;EAEA;GACC,gBAAgB;;GAEhB;;IAEC,SAAS;IACT,gBAAgB;IAChB,YAAY;GACb;;GAEA;;IAEC,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;GAClB;;GAEA;IACC,uCAAuC;IACvC,gCAAgC;IAChC,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC,gCAAgC;GACjC;;GAEA;;IAEC,WAAW;GACZ;EACD;;EAEA;GACC,gBAAgB;;GAEhB;;IAEC,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;GACb;;GAEA;IACC,sCAAsC;GACvC;;GAEA;;IAEC,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;GAClB;;GAEA;IACC,uCAAuC;IACvC,gCAAgC;IAChC,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC,gCAAgC;GACjC;EACD;;EAEA;GACC,gBAAgB;GAChB,4CAA4C;;GAE5C;;IAEC,qBAAqB;GACtB;;GAEA;IACC,2BAA2B;IAC3B,gBAAgB;GACjB;;GAEA;IACC,uBAAuB;IACvB,gBAAgB;GACjB;;GAEA;IACC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,uBAAuB;IACvB,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC,gCAAgC;;IAEhC;KACC,oBAAoB;KACpB,sBAAsB;KACtB,kBAAkB;KAClB,mBAAmB;KACnB,2BAA2B;KAC3B,YAAY;KACZ,iBAAiB;KACjB,WAAW;;KAEX;MACC,eAAe;MACf,gBAAgB;KACjB;;KAEA;MACC,eAAe;MACf,oBAAoB;MACpB,sBAAsB;;MAEtB;OACC,cAAc;OACd,oBAAoB;OACpB,sBAAsB;OACtB,mBAAmB;;OAEnB;QACC,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,QAAQ;;QAER;SACC,WAAW;SACX,YAAY;SACZ,kBAAkB;SAClB,uCAAuC;SACvC,SAAS;SACT,UAAU;;SAEV;UACC,qCAAqC;SACtC;QACD;;QAEA;SACC,eAAe;SACf,gBAAgB;QACjB;OACD;;OAEA;QACC,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,8BAA8B;QAC9B,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;;QAEf;SACC,aAAa;QACd;;QAEA;SACC,gCAAgC;QACjC;;QAEA;SACC,eAAe;SACf,gBAAgB;QACjB;;QAEA;SACC,YAAY;SACZ,eAAe;SACf,gBAAgB;QACjB;OACD;MACD;KACD;IACD;GACD;EACD;;EAEA;GACC,gBAAgB;;GAEhB;IACC,yCAAyC;IACzC,uCAAuC;IACvC,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;GACjB;;GAEA;;IAEC,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC;KACC,mBAAmB;IACpB;;IAEA;;KAEC,gCAAgC;IACjC;GACD;;GAEA;IACC,gCAAgC;IAChC,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,aAAa;;IAEb;KACC,aAAa;KACb,sBAAsB;KACtB,QAAQ;KACR,qCAAqC;KACrC,YAAY;IACb;;IAEA;KACC,eAAe;KACf,yBAAyB;KACzB,gBAAgB;KAChB,eAAe;IAChB;;IAEA;KACC,oBAAoB;KACpB,mBAAmB;KACnB,WAAW;KACX,8BAA8B;KAC9B,8BAA8B;KAC9B,iBAAiB;;KAEjB;MACC,aAAa;MACb,mBAAmB;MACnB,QAAQ;;MAER;OACC,qCAAqC;OACrC,kCAAkC;OAClC,gBAAgB;OAChB,kBAAkB;OAClB,eAAe;OACf,gBAAgB;MACjB;KACD;IACD;GACD;EACD;;EAEA;GACC,gBAAgB;;GAEhB;IACC;KACC,eAAe;KACf,gBAAgB;KAChB,iBAAiB;KACjB,eAAe;KACf,gBAAgB;IACjB;;IAEA;KACC,uCAAuC;KACvC,gCAAgC;KAChC,yCAAyC;KACzC,eAAe;KACf,gBAAgB;KAChB,YAAY;IACb;;IAEA;KACC;MACC,gBAAgB;MAChB,eAAe;MACf,gBAAgB;MAChB,8BAA8B;MAC9B,iCAAiC;KAClC;IACD;GACD;;GAEA;IACC,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,gCAAgC;IAChC,yCAAyC;IACzC,gBAAgB;GACjB;EACD;CACD;AACD;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,gBAAgB;CAChB,6BAA6B;CAC7B,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,sCAAsC;CACtC,kCAAkC;;CAElC;EACC,+BAA+B;CAChC;;CAEA;EACC;GACC,cAAc;GACd,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;EACxB;CACD;AACD;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,2BAA2B;CAC3B,6CAA6C;CAC7C,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,2BAA2B;CAC3B,2CAA2C;CAC3C,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,uBAAuB;CACvB,sBAAsB;CACtB,2BAA2B;CAC3B,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,sBAAsB;CACtB,WAAW;AACZ;;AAEA;AACA,YAAY;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;EACb,WAAW;CACZ,mBAAmB;CACnB,4CAA4C;AAC7C;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,WAAW;CACX,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;CACb,6CAA6C;CAC7C,8BAA8B;CAC9B,0CAA0C;AAC3C;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,SAAO;CACP,kBAAkB;CAClB,aAAa;CACb,iBAAiB;CACjB,6CAA6C;CAC7C,gCAAgC;CAChC,kBAAkB;CAClB,iBAAiB;CACjB,0CAA0C;AAC3C;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,SAAO;CACP,iBAAiB;CACjB,aAAa;CACb,yBAAiB;SAAjB,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,sCAAsC;CACtC,0CAA0C;AAC3C;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA;CACC,6CAA6C;CAC7C,YAAY;CACZ,kBAAkB;CAClB,gCAAgC;CAChC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,uCAAuC;CACvC;;4BAE2B;CAC3B,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,eAAe;CACf,gCAAgC;CAChC,WAAW;CACX,YAAY;;CAEZ;EACC,uCAAuC;EACvC,sBAAsB;CACvB;;CAEA;EACC,gCAAgC;EAChC,sBAAsB;CACvB;;;AAGD;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,YAAY;CACZ,gBAAgB;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,gCAAgC;IAChC,UAAU;AACd;;;AAGA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,sBAAsB;CACtB,sBAAsB;CACtB,eAAe;CACf,sCAAsC;CACtC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,eAAe;CACf,6CAA6C;CAC7C,6CAA6C;;CAE7C;EACC,eAAe;EACf,kCAAkC;EAClC,gBAAgB;CACjB;AACD;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,mBAAmB;CACnB,2BAA2B;;CAE3B,qCAAqC;CACrC,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,MAAM;CACN,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,6CAA6C;CAC7C,gCAAgC;CAChC,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,8BAA8B;CAC9B,eAAe;CACf;;4BAE2B;;CAE3B;EACC,oCAAoC;EACpC,sBAAsB;CACvB;;CAEA;EACC,uCAAuC;EACvC,sBAAsB;CACvB;AACD;;AAEA;CACC,6CAA6C;CAC7C,gCAAgC;CAChC,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,8BAA8B;CAC9B,eAAe;CACf,eAAe;CACf,WAAW;CACX,eAAe;CACf,YAAY;;CAEZ,cAAc;CACd;;4BAE2B;;CAE3B;EACC,oCAAoC;EACpC,sBAAsB;CACvB;;CAEA;EACC,uCAAuC;EACvC,sBAAsB;CACvB;AACD;;AAEA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,wCAAwC;CACxC,2CAA2C;IACxC,yBAAyB;AAC7B;;AAEA;CACC,aAAa;CACb,WAAW;CACX,kBAAkB;CAClB,oCAAoC;CACpC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,eAAe;CACf,wBAAwB;CACxB,2BAA2B;CAC3B,uBAAuB;CACvB,iBAAiB;CACjB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,2BAA2B;CAC3B,kBAAkB;CAClB,gBAAgB;CAChB,QAAQ;CACR,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,QAAQ;CACR,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,mBAAmB;CACnB,2BAA2B;CAC3B,kBAAkB;CAClB,kBAAkB;;CAElB;EACC,6CAA6C;;EAE7C;GACC,yBAAyB;EAC1B;CACD;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,YAAY;CACZ,cAAc;CACd,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,2BAA2B;CAC3B,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,eAAe;CACf,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,yBAAyB;CACzB,sCAAsC;AACvC;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,8BAA8B;CAC9B,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,2BAA2B;CAC3B,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,cAAc;AACf;;AAEA;;CAEC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,sCAAsC;AACvC;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;;CAEX;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,sBAAsB;CACtB,kBAAkB;CAClB,6CAA6C;CAC7C,oCAAoC;AACrC;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,uBAAuB;CACvB,gCAAgC;CAChC,2BAA2B;CAC3B,gBAAgB;CAChB,WAAW;CACX,4CAA4C;AAC7C;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,sCAAsC;IACnC,kBAAkB;IAClB,WAAW;IACX,+BAA+B;AACnC;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,gBAAgB;CAChB,OAAO;CACP,sCAAsC;IACnC,kBAAkB;IAClB,WAAW;IACX,+BAA+B;AACnC;;;AAGA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,WAAW;CACX,gBAAgB;CAChB,QAAQ;AACT;;;AAGA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,6BAA6B;CAC7B,aAAa;CACb,WAAW;CACX,SAAS;CACT,yCAAyC;CACzC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,6BAA6B;CAC7B,aAAa;CACb,WAAW;CACX,SAAS;CACT,4CAA4C;CAC5C,yCAAyC;CACzC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,gCAAgC;CAChC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,uBAAuB;CACvB,kBAAkB;CAClB,WAAW;CACX,2BAA2B;CAC3B,YAAY;CACZ,kBAAkB;CAClB,SAAS;CACT,wCAAwC;;CAExC;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,2BAA2B;CAC3B,wCAAwC;AACzC;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,6CAA6C;CAC7C,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,uBAAuB;CACvB,sBAAsB;CACtB,QAAQ;CACR,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uCAAuC;CACvC,qCAAqC;CACrC,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,sBAAsB;CACtB,YAAY;CACZ,uBAAuB;CACvB,qCAAqC;CACrC,kBAAkB;CAClB,wCAAwC;CACxC,aAAa;CACb,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,gCAAgC;CAChC,mBAAmB;CACnB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,8BAA8B;;CAE9B;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;GACC;;8BAE2B;GAC3B,eAAe;GACf,yBAAiB;WAAjB,iBAAiB;GACjB,YAAY;GACZ,uCAAuC;GACvC,gCAAgC;GAChC,kBAAkB;;GAElB;IACC,uCAAuC;IACvC,sBAAsB;GACvB;;GAEA;IACC,gCAAgC;IAChC,sBAAsB;GACvB;;GAEA;IACC,UAAU;IACV,WAAW;GACZ;EACD;CACD;AACD;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,+BAA+B;;CAE/B;EACC,qCAAqC;CACtC;;CAEA;EACC,qCAAqC;CACtC;;CAEA;EACC,oCAAoC;CACrC;;CAEA;EACC,uCAAuC;CACxC;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,aAAa;CACb,WAAW;AACZ;;AAEA;IACI,YAAY,IAAI,6BAA6B;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;CACC;GACE,wBAAwB;CAC1B;EACC;;AAEF;CACC,YAAY;CACZ,gCAAgC;CAChC,WAAW;CACX,aAAa;CACb,qBAAqB;CACrB,uBAAuB;CACvB,UAAU;CACV,eAAe;CACf,gCAAgC;CAChC,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB","sourcesContent":[":global(.react-datepicker__input-container) {\n\tinput {\n\t\tbackground: transparent;\n\t}\n}\n\n\n.modal {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\n\theight: 100%;\n\tbackground: var(--_00000020-background);\n\tz-index: 1000;\n\tz-index: 9999999;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\n\t.modalContent {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground: #ffffff;\n\t\tborder-radius: 10px;\n\t\tpadding: 10px;\n\t\tmax-width: 500px;\n\t\tmax-height: 500px;\n\t\toverflow-y: scroll;\n\t\toverflow-x: hidden;\n\t}\n}\n\n\n\n.header {\n\tflex-direction: column;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 4px;\n\twidth: 100%;\n\t/* width: calc(100% - 200px); */\n\tjustify-content: space-between;\n\tbackground: var(--white-color);\n\tpadding: 2px 0px;\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t.top {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 6px;\n\t\t/* flex-direction: column; */\n\n\t\t.buttons {\n\t\t\tdisplay: inline-flex;\n\t\t\talign-items: center;\n\t\t\tgap: 4px;\n\n\t\t\tsvg {\n\t\t\t\twidth: 20px;\n\t\t\t\tmin-width: 20px;\n\t\t\t\tmin-height: 20px;\n\t\t\t}\n\t\t}\n\n\t\t\n\n\t\t.expand {\n\t\t\twidth: 33px;\n\t\t\theight: 33px;\n\t\t\tborder: none;\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\t\t\tborder-radius: 4px;\n\t\t\tbackground: var(--fa-background);\n\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--border-color);\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\tmin-width: 25px;\n\t\t\t\tmin-height: 25px;\n\t\t\t\twidth: 25px;\n\t\t\t}\n\t\t}\n\n\t\t.toDay {\n\t\t\tbackground: var(--fa-background);\n\t\t\tpadding: 6px 12px;\n\t\t\tborder-radius: 4px;\n\t\t\tborder: none;\n\t\t\toutline: none;\n\t\t\twidth: 77px;\n\t\t\tmin-width: 60px;\n\t\t\tcursor: pointer;\n\t\t\tfont-family: inherit;\n\t\t\twidth: max-content;\n\t\t\tfont-size: 18px;\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t.actualToday {\n\t\t\tborder: none !important;\n\t\t\toutline: none;\n\t\t\tcursor: pointer;\n\t\t\tfont-family: inherit;\n\t\t\twidth: 77px;\n\t\t\tmin-width: 77px;\n\t\t\tbackground-color: var(--_16c0982e-background);\n\t\t\tcolor: var(--_16c098-background);\n\t\t\t/* color: var(--white-color); */\n\t\t\t/* background: var(--_10a37f-background); */\n\t\t\t/* border: 1px solid var(--_10a37f-background); */\n\t\t\tpadding: 2px 10px;\n\t\t\twidth: max-content;\n\t\t\tborder-radius: 4px;\n\t\t\tfont-size: 17px;\n\t\t}\n\n\t\t.toReturn {\n\t\t\tbackground: var(--_16c0982e-background);\n\t\t\tborder: none;\n\t\t\toutline: none;\n\t\t\tcursor: pointer;\n\t\t\tfont-family: inherit;\n\t\t\tborder: 1px solid var(--border-color);\n\t\t\tpadding: 6px 12px;\n\t\t\twidth: max-content;\n\t\t\tborder-radius: 4px;\n\t\t\tfont-size: 17px;\n\t\t}\n\n\t\t.buttonsNavs {\n\t\t\tdisplay: inline-flex;\n\t\t\talign-items: center;\n\t\t\tgap: 5px;\n\n\t\t\tbutton {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t\tcolor: var(--_16c098-background);\n\t\t\t\tcursor: pointer;\n\n\t\t\t\tsvg {\n\t\t\t\t\tmin-width: 26px;\n\t\t\t\t\tmin-height: 26px;\n\t\t\t\t\tcolor: var(--_16c0982e-background);\n\t\t\t\t\tfill: transparent;\n\t\t\t\t\twidth: 26px;\n\t\t\t\t}\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--_16c098-background);\n\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t[class^='react-datepicker-wrapper'] {\n\t\tdisplay: inline-flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 10px 10px;\n\t\theight: 40px;\n\t\tborder-radius: 4px;\n\t\tborder: 1px solid var(--border-color);\n\n\t\tinput {\n\t\t\twidth: 110px;\n\t\t\toutline: none;\n\t\t}\n\t}\n\n\t.buttonsCalendars {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\t\toverflow-x: scroll;\n\t\tflex-direction: column;\n\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\tbutton {\n\t\t\tbackground: var(--fa-background);\n\t\t\tborder: none;\n\t\t\toutline: none;\n\t\t\tcursor: pointer;\n\t\t\tfont-family: inherit;\n\t\t\tborder: 1px solid var(--border-color);\n\t\t\tpadding: 1px 7px;\n\t\t\tborder-radius: 4px;\n\t\t\tfont-size: 18px;\n\t\t\tdisplay: inline-flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\t&.active {\n\t\t\t\tborder-color: var(--_10a37f-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tborder-color: var(--_16c098-background);\n\t\t\t\tcolor: var(--_16c098-background);\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\tmin-width: 20px;\n\t\t\t\twidth: 20px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.kanbanButton {\n\tbackground: var(--fa-background);\n\tborder: none;\n\toutline: none;\n\tcursor: pointer;\n\tfont-family: inherit;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 1px solid var(--border-color);\n\tpadding: 6px 4px 6px 12px;\n\twidth: max-content;\n\ttext-wrap: nowrap;\n\tborder-radius: 4px;\n\tfont-size: 17px;\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 2px;\n\n\t&.active {\n\t\tborder-color: var(--_10a37f-background);\n\t\tcolor: var(--_10a37f-background);\n\t}\n\n\t&:hover {\n\t\tborder-color: var(--_16c098-background);\n\t\tcolor: var(--_16c098-background);\n\t}\n\n\tsvg {\n\t\tmin-width: 22px;\n\t\twidth: 22px;\n\t}\n}\n\n.container {\n\twidth: 100%;\n\tbackground: #fff;\n\tborder-radius: 20px 0px 0px 0px;\n\toverflow: hidden;\n\n\t.app {\n\t\tbackground: var(--white-color);\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\t\tgap: 2px;\n\t\theight: 100%;\n\t\toverflow: hidden;\n\t\t/* height: calc(100vh - 88px); */\n\t\toverflow: hidden;\n\t\t/* display: flex; */\n\t\tflex-direction: row;\n\t\twidth: 100%;\n\n\t}\n}\n\n.firstTh {\n\tborder-bottom: none !important;\n}\n\n.hourZoneWrapper {\n\tposition: relative;\n\tbackground: var(--f5-background) !important;\n\tborder-top: none !important;\n}\n\n.weekHourContent {\n\tposition: relative !important;\n}\n\n.hourContent {\n\tpadding-left: 10px;\n\tposition: relative !important;\n\tdisplay: flex;\n\tborder-top: none !important;\n\tflex-direction: row;\n}\n\n.eventPopup {\n\tposition: absolute !important;\n\ttop: 97px;\n\tborder-radius: 8px;\n\tz-index: 700000;\n}\n\n.selectedHourContent {\n\tdisplay: flex;\n\twidth: 100%;\n\tmargin-right: 2px;\n\tpadding: 2px 5px;\n\tflex-direction: column;\n\tborder-radius: 4px;\n\tjustify-content: flex-start;\n\tcolor: var(--white-color);\n\talign-items: flex-start;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\theight: 100%;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n\tcursor: pointer;\n\tuser-select: none;\n\topacity: 0.8;\n\tposition: relative;\n\ttransition: all 0.2s ease-in-out;\n\n\t&:hover {\n\t\topacity: 1;\n\t}\n}\n\n.monthTr {\n\twidth: 100%;\n}\n\n.monthTd {\n\tposition: relative;\n\tmin-width: 150px;\n}\n\n.monthDayHeader {\n\tfont-weight: 600;\n\tfont-size: 15px;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 35px;\n\tborder: none !important;\n}\n\n.hourZoneInner {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\tbottom: -1px;\n\twidth: calc(100% - 10px);\n\tright: 10px;\n\tz-index: 100000;\n\tbackground: var(--f5-background);\n\tcolor: var(--_10a37f-background);\n\tpadding: 2px 8px;\n\tfont-size: 11px;\n\tfont-weight: 500;\n}\n\n.dayMonthContainer {\n\tposition: relative;\n}\n\n.dayMonthInnerContainerWrapper {\n\tposition: absolute;\n\tpadding-left: 5px;\n\tleft: -1px;\n\ttop: 0;\n\tpadding-top: 5px;\n\twidth: calc(100% + 1px);\n\tbackground: var(--f5-background);\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n}\n\n.dayMonthInnerContainerWrapperWeek {\n\tposition: absolute;\n\tpadding-left: 5px;\n\tleft: -1px;\n\ttop: 0;\n\tpadding-top: 5px;\n\twidth: calc(100% + 1px);\n\tbackground: var(--f5-background);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n\tz-index: 100000;\n}\n\n.dayMonthInnerContainer {\n\tdisplay: flex;\n\tpadding-left: 5px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n}\n\n.dayText {\n\tcolor: var(--_16c098-background);\n\tfont-weight: 500;\n\tfont-size: 12px;\n}\n\n.dayCircle {\n\twidth: 45px;\n\theight: 45px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n\tfont-size: 26px;\n\tpadding-right: 1px;\n\tfont-weight: 500;\n\tbackground-color: var(--_16c098-color);\n\tcolor: var(--white-color);\n}\n\n.selectedDayCircle {\n\twidth: 45px;\n\theight: 45px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 8px;\n\tfont-size: 26px;\n\tpadding-right: 1px;\n\tfont-weight: 500;\n\tbackground-color: var(--_16c098-background);\n\tcolor: var(--white-color);\n}\n\n.hourContainer {\n\tposition: absolute;\n\ttop: -9px;\n\tright: 10px;\n\tbackground: var(--f5-background);\n\twidth: calc(100% - 10px);\n\tpadding-right: 5px;\n}\n\n.belowGMTTd {\n\tbackground: var(--f5-background);\n\tborder-left: none !important;\n\tmax-width: 70px !important;\n}\n\n.closeWrapper {\n\twidth: 20px;\n\theight: 20px;\n\tline-height: 17px;\n\tmargin-left: 6px;\n\tbackground-color: #dc3545;\n\tborder-radius: 50%;\n\tfont-size: 20px;\n\tcolor: var(--white-color);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\tdisplay: none;\n\n\t&:hover {\n\t\tbackground: red;\n\t}\n}\n\n.kanbanButton {\n\t&:hover {\n\t\t.closeWrapper {\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n}\n\n.closeWrapper svg {\n\tcolor: var(--e6fff9-background);\n}\n\n.closeWrapper:hover svg {\n\tcolor: var(--white-color);\n}\n\n.tableCalendar {\n\twidth: 100%;\n\theight: 100%;\n\toverflow: scroll;\n\n\ttable {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tborder: none;\n\n\t\tth {\n\t\t\ttext-align: left;\n\t\t\tmin-height: 100px;\n\t\t}\n\n\t\ttd {\n\t\t\tborder: 1px solid var(--border-color);\n\t\t\ttext-align: center;\n\t\t\tbackground-color: var(--white-color);\n\n\t\t\t&.active {\n\t\t\t\tbackground: var(--_16c09821-background);\n\t\t\t\tborder-color: var(--_16c098-color);\n\t\t\t\tcolor: var(--_16c098-color);\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--e6fff9-background);\n\t\t\t\t\tborder-color: var(--_16c09821-background);\n\t\t\t\t\tcolor: var(--_16c09821-background);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.calendarDay {\n\t\t\tmin-width: 750px;\n\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\twidth: 7%;\n\t\t\t\tmin-height: 40px;\n\t\t\t\theight: 40px;\n\t\t\t}\n\n\t\t\tth:nth-child(1),\n\t\t\ttd:nth-child(1) {\n\t\t\t\tposition: relative;\n\t\t\t\tmin-width: 70px;\n\t\t\t\twidth: 70px;\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--border-color);\n\t\t\t\tborder-left: none !important;\n\t\t\t\tborder-right: none !important;\n\t\t\t\tpadding: 2px 5px;\n\t\t\t\tfont-size: 11px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\tpadding: 2px 9px;\n\t\t\t\tfont-size: 15px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\n\t\t\tth:nth-child(1) {\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t}\n\n\t\t\tth:nth-child(2),\n\t\t\ttd:nth-child(2) {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&.calendarWeek {\n\t\t\tmin-width: 750px;\n\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\twidth: 11vw !important;\n\t\t\t\tmin-height: 40px;\n\t\t\t\theight: 40px;\n\t\t\t}\n\n\t\t\ttbody {\n\t\t\t\tbackground-color: var(--f5-background);\n\t\t\t}\n\n\t\t\tth:nth-child(1),\n\t\t\ttd:nth-child(1) {\n\t\t\t\tposition: relative;\n\t\t\t\tmin-width: 70px;\n\t\t\t\twidth: 70px !important;\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--border-color);\n\t\t\t\tborder-left: none !important;\n\t\t\t\tborder-right: none !important;\n\t\t\t\tpadding: 2px 5px;\n\t\t\t\tfont-size: 11px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\tpadding: 2px 9px;\n\t\t\t\tfont-size: 15px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\n\t\t\tth:nth-child(1) {\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t}\n\t\t}\n\n\t\t&.calendarMonth {\n\t\t\tmin-width: 750px;\n\t\t\t/* border: 1px solid var(--f5-background); */\n\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\twidth: calc(100% / 7);\n\t\t\t}\n\n\t\t\ttable {\n\t\t\t\tborder-top: none !important;\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\n\t\t\tthead {\n\t\t\t\tborder: none !important;\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\ttext-align: center;\n\t\t\t\tborder-radius: 0;\n\t\t\t\tborder-bottom: none;\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder: none !important;\n\t\t\t\tfont-size: 11px;\n\t\t\t\tpadding-top: 2px;\n\t\t\t}\n\n\t\t\ttd {\n\t\t\t\theight: calc((100vh / 5) - 26px);\n\n\t\t\t\t.day {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tmax-height: 175px;\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\tb {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-weight: 800;\n\t\t\t\t\t}\n\n\t\t\t\t\tul {\n\t\t\t\t\t\tmargin-top: 4px;\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\tflex-direction: column;\n\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\t\talign-items: center;\n\n\t\t\t\t\t\t\t.date {\n\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\t\t\t\tgap: 8px;\n\n\t\t\t\t\t\t\t\t.dot {\n\t\t\t\t\t\t\t\t\twidth: 10px;\n\t\t\t\t\t\t\t\t\theight: 10px;\n\t\t\t\t\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\t\t\tpadding: 0;\n\n\t\t\t\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.info {\n\t\t\t\t\t\t\t\twidth: 80px;\n\t\t\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\t\tbackground: var(--white-color);\n\t\t\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\t\t\tpadding: 2px 4px;\n\t\t\t\t\t\t\t\ttext-wrap: nowrap;\n\t\t\t\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t\t\t\t&::-webkit-scrollbar {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tbackground: var(--f5-background);\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\tb {\n\t\t\t\t\t\t\t\t\twidth: 100px;\n\t\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.schedule {\n\t\t\tmin-width: 750px;\n\n\t\t\tth {\n\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tpadding: 4px 10px;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\n\t\t\ttd:nth-child(1),\n\t\t\ttd:nth-child(2) {\n\t\t\t\tpadding: 10px;\n\t\t\t\tbackground: var(--white-color);\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-size: 12px;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\n\t\t\ttr:last-child {\n\t\t\t\ttd {\n\t\t\t\t\tborder-bottom: none;\n\t\t\t\t}\n\n\t\t\t\ttd:nth-child(1),\n\t\t\t\ttd:nth-child(2) {\n\t\t\t\t\tbackground: var(--f5-background);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.events {\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 2px;\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 10px;\n\n\t\t\t\t.item {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tgap: 2px;\n\t\t\t\t\tborder: 1px solid var(--border-color);\n\t\t\t\t\tpadding: 6px;\n\t\t\t\t}\n\n\t\t\t\tstrong {\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tline-height: 2px;\n\t\t\t\t\tmargin-top: 7px;\n\t\t\t\t}\n\n\t\t\t\t.headerEvent {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\tbackground: var(--white-color);\n\t\t\t\t\tpadding: 4px 10px;\n\n\t\t\t\t\tdiv {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tgap: 8px;\n\n\t\t\t\t\t\tlabel {\n\t\t\t\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t\t\t\t\tcolor: var(--_16c0982e-background);\n\t\t\t\t\t\t\tpadding: 2px 8px;\n\t\t\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.timeLine {\n\t\t\tmin-width: 750px;\n\n\t\t\tthead {\n\t\t\t\tth:nth-child(1) {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tpadding: 4px 10px;\n\t\t\t\t\tfont-size: 23px;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\n\t\t\t\tth {\n\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tpadding: 6px;\n\t\t\t\t}\n\n\t\t\t\ttr:nth-child(1) {\n\t\t\t\t\tth {\n\t\t\t\t\t\tpadding: 2px 9px;\n\t\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\tbackground: var(--white-color);\n\t\t\t\t\t\tborder-color: var(--border-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\ttd:nth-child(1) {\n\t\t\t\tmin-width: 230px;\n\t\t\t\twidth: 230px;\n\t\t\t\tpadding: 10px;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--_16c0982e-background);\n\t\t\t\ttext-align: left;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.notScrollableTableCalendar {\n\toverflow: hidden !important;\n}\n\n.calendarDayHeader {\n\tmin-height: 100px !important;\n}\n\n.monthDayLi {\n\tpadding: 3px;\n\tborder-radius: 2px;\n\tdisplay: flex;\n\twidth: 100%;\n\tmin-width: 140px;\n\tposition: relative !important;\n\tcursor: pointer;\n\tuser-select: none;\n\tjustify-content: flex-start !important;\n\talign-items: flex-start !important;\n\n\t&:hover {\n\t\tbackground: var(--border-color);\n\t}\n\n\tdiv {\n\t\tspan {\n\t\t\tmax-width: 90%;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\t}\n}\n\n.monthDayContainer {\n\tmargin: 2px;\n\tborder-radius: 5px;\n\tfont-size: 10px;\n\twidth: 25px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 25px;\n\tfont-weight: 400 !important;\n\tbackground-color: var(--_16c0982e-background);\n\tcolor: var(--_16c098-background);\n}\n\n.selectedMonthDayContainer {\n\tmargin: 2px;\n\tborder-radius: 50%;\n\tfont-size: 10px;\n\twidth: 25px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 25px;\n\tfont-weight: 400 !important;\n\tbackground-color: var(--_16c098-background);\n\tcolor: var(--white-color);\n}\n\n.scheduleWrapper {\n\tmin-width: 750px;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\twidth: 100%;\n}\n\n.scheduleEventsContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.calendarSchedule{\npadding: 8px;\n}\n\n.calendarContainer {\n\twidth: 100%;\n\theight: 100%;\n\tflex: 1 1 auto; \n  min-width: 0\n\t/* padding: 20px; */\n\t/* background-color: var(--f5-background); */\n}\n\n.navigation {\n\tmargin-bottom: 10px;\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 10px;\n\tbackground-color: var(--_16c0982e-background);\n\tborder-radius: 8px 8px 0px 0px;\n\tbox-shadow: 2px 3px 5px rgba(0, 0, 0, 0.2);\n}\n\n.monthLabel {\n\tfont-weight: bold;\n\tfont-size: 18px;\n\tcolor: var(--_10a37f-background);\n}\n\n.daysRow {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 10px;\n\tbackground: transparent;\n}\n\n.dayHeader {\n\tflex: 1;\n\ttext-align: center;\n\tpadding: 10px;\n\tfont-weight: bold;\n\tbackground-color: var(--_16c0982e-background);\n\tcolor: var(--_10a37f-background);\n\tborder-radius: 5px;\n\tmargin-right: 2px;\n\tbox-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.weekRows {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.weekRow {\n\tdisplay: flex;\n\tmargin-bottom: 2px;\n}\n\n.dayCell {\n\tflex: 1;\n\tmin-height: 100px;\n\tpadding: 10px;\n\tuser-select: none;\n\tmargin-right: 2px;\n\tborder-radius: 4px;\n\tposition: relative;\n\tbackground-color: var(--_16c098-color);\n\tbox-shadow: 2px 3px 5px rgba(0, 0, 0, 0.2);\n}\n\n.dateNumber {\n\tfont-weight: bold;\n\tmargin-bottom: 5px;\n\tcolor: var(--_10a37f-background);\n}\n\n.eventText {\n\tbackground-color: var(--_16c09821-background);\n\tpadding: 5px;\n\tborder-radius: 5px;\n\tcolor: var(--_10a37f-background);\n\tfont-size: 12px;\n\ttext-align: center;\n}\n\n.chevronContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 4px;\n\tbackground: var(--_16c0982e-background);\n\ttransition:\n\t\tbackground 0.2s ease-in-out,\n\t\ttransform 0.1s ease-in-out;\n\tcursor: pointer;\n\tuser-select: none;\n\tfont-size: 18px;\n\tcolor: var(--_10a37f-background);\n\twidth: 40px;\n\theight: 35px;\n\n\t&:hover {\n\t\tbackground: var(--_16c0982e-background);\n\t\ttransform: scale(1.05);\n\t}\n\n\t&:active {\n\t\tbackground: var(--_16c098-color);\n\t\ttransform: scale(0.95);\n\t}\n\n\n}\n\n.calendarMonthWrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\theight: 100%;\n\tmax-width: 100px;\n    /* max-height: 500px; */\n    overflow-y: visible;\n}\n\n.calendarMonth thead th {\n    position: sticky;\n    top: 0;\n    background: var(--fa-background);\n    z-index: 1;\n}\n\n\n.timeline {\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 10px 20px 10px 70px;\n\tflex-direction: column;\n\t/* min-width: 990px; */\n\tmax-width: 100%;\n\tbackground-color: var(--fa-background);\n\tposition: relative;\n}\n\n.timelineHeader {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tborder-radius: 4px;\n\talign-items: center;\n\tpadding: 0px 5px;\n\theight: 35px;\n\tmargin-bottom: 10px;\n\tfont-size: 12px;\n\tbackground-color: var(--_16c0982e-background);\n\tborder: 1px solid var(--_16c0982e-background);\n\n\tspan {\n\t\tfont-size: 14px;\n\t\tcolor: var(--_16c09821-background);\n\t\tfont-weight: 600;\n\t}\n}\n\n.dayContainer {\n\tdisplay: flex;\n\theight: 35px;\n\tmin-height: 35px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\n\tborder: 1px solid var(--border-color);\n\tborder-radius: 4px;\n\tmargin-bottom: 15px;\n\tposition: sticky;\n\ttop: 0;\n\tbackground: #fff;\n\tz-index: 2;\n}\n\n.navArrowsContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.navArrow {\n\tbackground-color: var(--_16c09821-background);\n\tcolor: var(--_16c098-background);\n\tborder: none;\n\theight: 100%;\n\tfont-size: 11px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\tborder-radius: 3px 0px 0px 3px;\n\tcursor: pointer;\n\ttransition:\n\t\tbackground 0.2s ease-in-out,\n\t\ttransform 0.1s ease-in-out;\n\n\t&:hover {\n\t\tbackground: var(--e6fff9-background);\n\t\ttransform: scale(1.05);\n\t}\n\n\t&:active {\n\t\tbackground: var(--_16c09821-background);\n\t\ttransform: scale(0.95);\n\t}\n}\n\n.navArrowRight {\n\tbackground-color: var(--_16c09821-background);\n\tcolor: var(--_16c098-background);\n\tborder: none;\n\theight: 100%;\n\tfont-size: 11px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\tborder-radius: 0px 3px 3px 0px;\n\tcursor: pointer;\n\tposition: fixed;\n\tright: 27px;\n\t/* top: 71px; */\n\theight: 33px;\n\n\tz-index: 50000;\n\ttransition:\n\t\tbackground 0.2s ease-in-out,\n\t\ttransform 0.1s ease-in-out;\n\n\t&:hover {\n\t\tbackground: var(--e6fff9-background);\n\t\ttransform: scale(1.05);\n\t}\n\n\t&:active {\n\t\tbackground: var(--_16c09821-background);\n\t\ttransform: scale(0.95);\n\t}\n}\n\n@media (max-width: 1308px) {\n\t.navArrowRight {\n\t\tright: 0px;\n\t}\n}\n\n.timelineDays {\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n}\n\n.timelineDay {\n\ttext-align: start;\n\tpadding: 0px 5px;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\t/* color: var(--_16c09821-background); */\n\tbackground-color: var(--_16c098-background);\n    color: var(--white-color);\n}\n\n.eventsContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\tposition: relative;\n\tbackground-color: var(--white-color);\n\theight: 100%;\n}\n\n.timelineEvents {\n\tdisplay: flex;\n\tmargin-top: 2px;\n\twidth: calc(100% - 60px);\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n\tmargin-left: 30px;\n\tz-index: 50000;\n\tposition: relative;\n}\n\n.eventsForDay {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tposition: relative;\n\toverflow-x: show;\n\tgap: 3px;\n\toverflow-y: auto;\n}\n\n.timelineEvent {\n\tbackground-color: #cfe9ff;\n\tcolor: #000;\n\tjustify-content: center;\n\tborder-radius: 5px;\n\ttext-align: center;\n\tfont-size: 12px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.timelineEventCard {\n\tdisplay: flex;\n\tflex-direction: row;\n\twidth: 100%;\n\tgap: 3px;\n\theight: 50px;\n\tmin-height: 50px;\n\tpadding: 0px 5px;\n\talign-items: center;\n\tcursor: pointer;\n\tuser-select: none;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tposition: relative;\n\tborder-radius: 3px;\n\n\t&:hover {\n\t\tbackground-color: var(--_16c0982e-background);\n\n\t\t.eventDesc {\n\t\t\tcolor: var(--white-color);\n\t\t}\n\t}\n}\n\n.eventColorDiv {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\theight: 37px;\n\tmin-width: 8px;\n\tborder-radius: 15px;\n\twidth: 8px;\n}\n\n.eventRightContainer {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tjustify-content: flex-start;\n\tgap: 3px;\n\tflex-direction: row;\n}\n\n.eventUserImage {\n\tdisplay: flex;\n\twidth: 27px;\n\tmax-width: 27px;\n\tmin-width: 27px;\n\theight: 27px;\n\tmax-height: 27px;\n\tmin-height: 27px;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 15px;\n\tfont-weight: bold;\n\tborder-radius: 50px;\n\tcolor: var(--white-color);\n\tbackground-color: var(--_16c098-color);\n}\n\n.eventData {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\theight: 100%;\n\tflex-direction: column;\n}\n\n.eventTitle {\n\tcolor: var(--_3c3a3a-color);\n\tfont-size: 13px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tfont-weight: 600;\n\ttext-overflow: ellipsis;\n\tline-height: 1.2;\n}\n\n.eventDesc {\n\tcolor: var(--text-color-secondary);\n\tfont-size: 11px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tline-height: 1;\n}\n\n.eventTitle,\n.eventDesc {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\ttransition: max-width 0.3s ease-in-out;\n}\n\n.timelineEventCard:hover .eventTitle,\n.timelineEventCard:hover .eventDesc {\n\tmax-width: none !important;\n}\n\n.showMoreButton {\n\tcolor: var(--_16c0982e-background);\n\tcursor: pointer;\n\tfont-size: 12px;\n\tmargin-left: -2px;\n\tfont-weight: 600;\n\ttext-align: center;\n\twidth: 100%;\n\n\t&:hover {\n\t\tcolor: var(--_16c098-color);\n\t}\n}\n\n.hoursWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\tflex-direction: column;\n\tborder-radius: 5px;\n\tborder: 1px solid var(--_16c0982e-background);\n\tbackground-color: var(--white-color);\n}\n\n.hourItem {\n\tfont-size: 11px;\n\tposition: relative;\n\tdisplay: flex;\n\tmargin-left: -22px;\n\talign-items: flex-start;\n\tcolor: var(--_10a37f-background);\n\tjustify-content: flex-start;\n\tfont-weight: 500;\n\twidth: 100%;\n\tborder-bottom: 1px solid var(--border-color);\n}\n\n.hourTextAbsolute{\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tposition: absolute;\n\theight: 100%;\n\tleft: -50px;\n\tbackground-color: var(--fa-background);\n    padding: 20px 20px;\n    width: 20px;\n    border-right: 1px solid #d5f4dc;\n}\n\n.hourText {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tposition: sticky;\n\tleft: 0;\n\tbackground-color: var(--fa-background);\n    padding: 20px 20px;\n    width: 20px;\n    border-right: 1px solid #d5f4dc;\n}\n\n\n.eventListContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\twidth: 100%;\n\tpadding: 0px 4px;\n\tgap: 2px;\n}\n\n\n.singleEventCardContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: transparent;\n\tpadding: 10px;\n\twidth: 100%;\n\tgap: 20px;\n\tborder-top: 1px solid var(--border-color);\n\tcursor: pointer;\n}\n\n.lastSingleEventCardContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: transparent;\n\tpadding: 10px;\n\twidth: 100%;\n\tgap: 20px;\n\tborder-bottom: 1px solid var(--border-color);\n\tborder-top: 1px solid var(--border-color);\n\tcursor: pointer;\n}\n\n.dateContainer {\n\tpadding: 3px;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tgap: 15px;\n\tcolor: #333;\n\tfont-weight: 600;\n\tmin-width: 70px;\n}\n\n.eventPopup {\n\tposition: absolute;\n\ttop: 97px;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tborder-radius: 8px;\n\tz-index: 700000;\n}\n\n.itemContainer {\n\tdisplay: flex;\n\tcursor: pointer;\n\tuser-select: none;\n\talign-items: flex-start;\n\tposition: relative;\n\twidth: 100%;\n\tjustify-content: flex-start;\n\tpadding: 8px;\n\tborder-radius: 5px;\n\tgap: 20px;\n\ttransition: background 0.01s ease-in-out;\n\n\t&:hover {\n\t\tbackground: var(--_16c0982e-background);\n\t}\n}\n\n.day {\n\tfont-size: 18px;\n\tfont-weight: bold;\n\tcursor: pointer;\n\tuser-select: none;\n\twidth: 30px;\n\theight: 30px;\n\tmin-width: 30px;\n\tmin-height: 30px;\n\tborder-radius: 50%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--_3c3a3a-color);\n\ttransition: background 0.01s ease-in-out;\n}\n\n.monthDayName {\n\tfont-size: 12px;\n\tcolor: var(--text-color-secondary);\n\twidth: 80px;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n}\n\n.timeContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tmin-width: 160px;\n}\n\n.dot {\n\twidth: 12px;\n\theight: 12px;\n\tborder-radius: 50%;\n\tbackground-color: var(--_16c09821-background);\n\tmargin-right: 15px;\n\tmargin-bottom: 2px;\n}\n\n.eventsContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\talign-items: flex-start;\n\tflex-direction: column;\n\tgap: 5px;\n\tjustify-content: flex-start;\n}\n\n.hour {\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: var(--text-color-secondary);\n}\n\n.eventDetails {\n\tflex-grow: 1;\n\tpadding-left: 10px;\n}\n\n.title {\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tcolor: var(--_3c3a3a-color);\n\tmargin-bottom: 2px;\n}\n\n.description {\n\tfont-size: 12px;\n\tcolor: var(--text-color-secondary);\n}\n\n.inputCalendarContainer {\n\tposition: relative;\n\tdisplay: inline-block;\n\tz-index: 99999999;\n\tmin-width: 120px;\n\tmax-width: 120px;\n}\n\n.inputWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: var(--_16c0982e-background);\n\tborder: 1px solid var(--border-color);\n\tpadding: 6px 12px;\n\theight: 100%;\n\tborder-radius: 4px;\n}\n\n.dateInput {\n\tborder: none;\n\toutline: none;\n\twidth: 100%;\n\ttext-align: center;\n\tcursor: pointer;\n\tfont-size: 17px;\n\tbackground: transparent;\n\tcolor: var(--_3c3a3a-color);\n}\n\n.clearButton {\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\tfont-size: 16px;\n\tmargin-left: auto;\n\tcolor: var(--_3c3a3a-color);\n}\n\n.calendarPopup {\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 0;\n\tflex-direction: column;\n\tz-index: 100;\n\tbackground-color: white;\n\tborder: 1px solid var(--border-color);\n\tborder-radius: 4px;\n\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\tpadding: 10px;\n\tmargin-top: 5px;\n\tz-index: 100000;\n}\n\n.miniCalendarWrapper {\n\tbackground: var(--f5-background);\n\tborder-radius: 10px;\n\tpadding: 2px;\n\toverflow: hidden;\n}\n\n.date {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tjustify-content: space-between;\n\n\tb {\n\t\tfont-size: 12px;\n\t\tfont-weight: 600;\n\t}\n\n\tdiv {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\n\t\tbutton {\n\t\t\ttransition:\n\t\t\t\tbackground 0.2s ease-in-out,\n\t\t\t\ttransform 0.1s ease-in-out;\n\t\t\tcursor: pointer;\n\t\t\tuser-select: none;\n\t\t\tpadding: 3px;\n\t\t\tbackground: var(--_16c0982e-background);\n\t\t\tcolor: var(--_10a37f-background);\n\t\t\tborder-radius: 6px;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\ttransform: scale(1.05);\n\t\t\t}\n\n\t\t\t&:active {\n\t\t\t\tbackground: var(--_16c098-color);\n\t\t\t\ttransform: scale(0.95);\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\twidth: 8px;\n\t\t\t\theight: 8px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.topDropContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 50px;\n\tmin-height: 50px;\n}\n\n.botDropContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 50px;\n\tmin-height: 50px;\n}\n\n.dot {\n\tmin-width: 10px;\n\twidth: 10px;\n\theight: 10px;\n\tborder-radius: 3px;\n\tbackground: var(--border-color);\n\n\t&._100 {\n\t\tbackground: var(--_10a37f-background);\n\t}\n\n\t&._101 {\n\t\tbackground: var(--_16c098-background);\n\t}\n\n\t&._102 {\n\t\tbackground: var(--e6fff9-background);\n\t}\n\n\t&._103 {\n\t\tbackground: var(--_16c09821-background);\n\t}\n\n\t&._200 {\n\t\tbackground: #dadada;\n\t}\n\n\t&._201 {\n\t\tbackground: #ffa914;\n\t}\n\n\t&._202 {\n\t\tbackground: #f7ff14;\n\t}\n\n\t&._203 {\n\t\tbackground: rgb(255, 30, 30);\n\t}\n\n\t&._204 {\n\t\tbackground: rgb(17, 209, 113);\n\t}\n}\n\n.newKanbanInput {\n\tdisplay: flex;\n\tborder: none;\n\toutline: none;\n\twidth: 80px;\n}\n\n.menu{\n    width: 300px;   /* O el ancho que prefieras */\n  max-width: 300px;\n  min-width: 220px;\n  flex: 0 0 300px;\n}\n\n@media (max-width: 600px) {\n\t.menu {\n\t  display: none !important;\n\t}\n  }\n\n.leftTimezone{\n\theight: 65px;\n\tbackground: var(--fa-background);\n\twidth: 70px;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: center;\n\tz-index: 2;\n\tfont-size: 11px;\n\tcolor: var(--_16c098-background);\n\tfont-weight: 600;\n\tpadding-bottom: 8px;\n\tborder-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__7Xgt`,
	"modalContent": `modalContent_BX8tV`,
	"header": `header_rbcz9`,
	"top": `top_HWDsl`,
	"buttons": `buttons_Ai0qT`,
	"expand": `expand_iVGcp`,
	"toDay": `toDay_ix2XU`,
	"actualToday": `actualToday_sjU40`,
	"toReturn": `toReturn_DYJ1D`,
	"buttonsNavs": `buttonsNavs_gYVjy`,
	"buttonsCalendars": `buttonsCalendars_Ih4g3`,
	"active": `active_NHxBQ`,
	"kanbanButton": `kanbanButton_pEP1d`,
	"container": `container_aR43l`,
	"app": `app_G708t`,
	"firstTh": `firstTh_hs73u`,
	"hourZoneWrapper": `hourZoneWrapper_g1lsX`,
	"weekHourContent": `weekHourContent_Ae1Xi`,
	"hourContent": `hourContent_KJ3mB`,
	"eventPopup": `eventPopup_mEC6S`,
	"selectedHourContent": `selectedHourContent_BDrj2`,
	"monthTr": `monthTr_TgRMB`,
	"monthTd": `monthTd_hiuCq`,
	"monthDayHeader": `monthDayHeader_Dovx6`,
	"hourZoneInner": `hourZoneInner_dW1NU`,
	"dayMonthContainer": `dayMonthContainer_jEkmT`,
	"dayMonthInnerContainerWrapper": `dayMonthInnerContainerWrapper_XHqjA`,
	"dayMonthInnerContainerWrapperWeek": `dayMonthInnerContainerWrapperWeek_N0aTW`,
	"dayMonthInnerContainer": `dayMonthInnerContainer_uathQ`,
	"dayText": `dayText_uIG3J`,
	"dayCircle": `dayCircle_Hu14e`,
	"selectedDayCircle": `selectedDayCircle_TneJq`,
	"hourContainer": `hourContainer_I2UMR`,
	"belowGMTTd": `belowGMTTd_SBo_F`,
	"closeWrapper": `closeWrapper_rVJWA`,
	"tableCalendar": `tableCalendar_cHS0D`,
	"calendarDay": `calendarDay_HenOX`,
	"calendarWeek": `calendarWeek_g6m6U`,
	"calendarMonth": `calendarMonth_mrg9s`,
	"day": `day_rDfh9`,
	"date": `date_n27pq`,
	"dot": `dot_AFUac`,
	"info": `info_xRorD`,
	"schedule": `schedule_avT8i`,
	"events": `events_jBCzF`,
	"item": `item_GTNjI`,
	"headerEvent": `headerEvent_gcUz3`,
	"timeLine": `timeLine_g2iSz`,
	"notScrollableTableCalendar": `notScrollableTableCalendar_RUaAN`,
	"calendarDayHeader": `calendarDayHeader_INPaM`,
	"monthDayLi": `monthDayLi_R5qKO`,
	"monthDayContainer": `monthDayContainer_Ykmro`,
	"selectedMonthDayContainer": `selectedMonthDayContainer_UilE6`,
	"scheduleWrapper": `scheduleWrapper_tzOni`,
	"scheduleEventsContainer": `scheduleEventsContainer_f2TD4`,
	"calendarSchedule": `calendarSchedule_aZQ2O`,
	"calendarContainer": `calendarContainer_RC5hh`,
	"navigation": `navigation_NFqBV`,
	"monthLabel": `monthLabel_fmiw6`,
	"daysRow": `daysRow_fow4f`,
	"dayHeader": `dayHeader_sDDPU`,
	"weekRows": `weekRows_o4cLy`,
	"weekRow": `weekRow_F9BnA`,
	"dayCell": `dayCell_kT95W`,
	"dateNumber": `dateNumber_sPgvB`,
	"eventText": `eventText_q5Blh`,
	"chevronContainer": `chevronContainer_DTLKa`,
	"calendarMonthWrapper": `calendarMonthWrapper_roQw3`,
	"timeline": `timeline_ZIg05`,
	"timelineHeader": `timelineHeader_WfKWP`,
	"dayContainer": `dayContainer_go5p3`,
	"navArrowsContainer": `navArrowsContainer_FbdjL`,
	"navArrow": `navArrow_cIh7r`,
	"navArrowRight": `navArrowRight_VLRZW`,
	"timelineDays": `timelineDays_Hip3z`,
	"timelineDay": `timelineDay_QE4Pm`,
	"eventsContainer": `eventsContainer_qvaHv`,
	"timelineEvents": `timelineEvents_rpZl_`,
	"eventsForDay": `eventsForDay_IJK3q`,
	"timelineEvent": `timelineEvent_LaVyS`,
	"timelineEventCard": `timelineEventCard_NOVbf`,
	"eventDesc": `eventDesc_LDNmf`,
	"eventColorDiv": `eventColorDiv_Xzzwe`,
	"eventRightContainer": `eventRightContainer_BW1AF`,
	"eventUserImage": `eventUserImage_kbsbZ`,
	"eventData": `eventData_PsfH9`,
	"eventTitle": `eventTitle_vDKOH`,
	"showMoreButton": `showMoreButton_Xmf3H`,
	"hoursWrapper": `hoursWrapper_soiYt`,
	"hourItem": `hourItem_sr1Al`,
	"hourTextAbsolute": `hourTextAbsolute_WzKbw`,
	"hourText": `hourText_GFq3n`,
	"eventListContainer": `eventListContainer__iDsP`,
	"singleEventCardContainer": `singleEventCardContainer_Rv5xD`,
	"lastSingleEventCardContainer": `lastSingleEventCardContainer_m84W6`,
	"dateContainer": `dateContainer_FTySb`,
	"itemContainer": `itemContainer_R4lMz`,
	"monthDayName": `monthDayName_yEjK3`,
	"timeContainer": `timeContainer_Ep8Ln`,
	"hour": `hour_BMBiE`,
	"eventDetails": `eventDetails_SFdN4`,
	"title": `title_vw2TJ`,
	"description": `description_baU6K`,
	"inputCalendarContainer": `inputCalendarContainer_n8n9Y`,
	"inputWrapper": `inputWrapper__JgCc`,
	"dateInput": `dateInput_Dw6Mw`,
	"clearButton": `clearButton_F_48g`,
	"calendarPopup": `calendarPopup_wwtfX`,
	"miniCalendarWrapper": `miniCalendarWrapper_r2YSw`,
	"topDropContainer": `topDropContainer_MSRW4`,
	"botDropContainer": `botDropContainer_xPpCO`,
	"_100": `_100_ficDJ`,
	"_101": `_101_vNx34`,
	"_102": `_102_H_Mpk`,
	"_103": `_103_HQbpP`,
	"_200": `_200_u3uNT`,
	"_201": `_201_o56jw`,
	"_202": `_202_ZyL8V`,
	"_203": `_203_e6ieT`,
	"_204": `_204_r4_sz`,
	"newKanbanInput": `newKanbanInput_q0Gy_`,
	"menu": `menu_OCnUV`,
	"leftTimezone": `leftTimezone_fW17U`
};
export default ___CSS_LOADER_EXPORT___;
